// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { endOfYear as fn } from "../endOfYear.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const endOfYearWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default endOfYearWithOptions;
